import View from "./View";
import icons from 'url:../../img/icons.svg';

class RegisterView extends View {

    _generateMarkup() {
        if (this._data.needLogin) {
            return `
                <div class="register__heading">
                    <img class="register__img" src="${this._data.logo}" alt="RASH Logo">
                </div>
                <form class="form">
                
                <input type="hidden" name="service" value="${this._data.id}">
                
                    <div class="form__group">
                        <select class="form__input form__input--select form__input--universities" 
                                name="universities" 
                                required>
                            <option class="select__option" value="">...Zgjidhni universitetin *</option>
                            ${this._generateMarkupSelectUniversities(this._data.universities)}
                        </select>
                        <hr class="form__line">
                        <svg class="form__icon">
                            <use href="${icons}#icon-chevron-thin-down"></use>
                        </svg>
                    </div>
                    
                    <div class="form__group">
                        <select class="form__input form__input--select form__input--faculties" 
                                name="faculties" 
                                disabled 
                                required>
                            <option class="select__option" value="">...Zgjidhni fakultetin *</option>
                        </select>
                        <hr class="form__line">
                        <svg class="form__icon">
                            <use href="${icons}#icon-chevron-thin-down"></use>
                        </svg>
                    </div>  
                    
                    <div class="form__group">
                        <input class="form__input form__input--first-name" 
                               type="text" 
                               name="firstName" 
                               placeholder="Emri *" 
                               required>     
                        <hr class="form__line">               
                    </div>              
                    <div class="form__group">
                        <input class="form__input form__input--last-name" 
                               type="text" 
                               name="lastName" 
                               placeholder="Mbiemri *" 
                               required>  
                        <hr class="form__line">                  
                    </div>                    
                    
                    <div class="form__group">
                        <select class="form__input form__input--select form__input--positions" 
                                name="positions" 
                                required>
                            <option class="select__option" value="">...Zgjidhni pozicionin *</option>
                            <option class="select__option" value="Staf Akademik">Staf Akademik</option>
                            <option class="select__option" value="Student">Student</option>
                        </select>
                        <hr class="form__line">
                        <svg class="form__icon">
                            <use href="${icons}#icon-chevron-thin-down"></use>
                        </svg>
                    </div>
                    <div class="form__group">
                        <input class="form__input form__input--email" 
                               type="email" 
                               placeholder="Email *" 
                               name="email" 
                               autocomplete="username" 
                               required 
                               disabled>
                        <hr class="form__line">
                    </div>                                               
                    <input class="form__button" type="submit" value="Regjistrohu">
                </form>
            `;
        }

        return `
            <div class="register register--logo">
                <img class="register__img register--logo__img" src="${this._data.logo}" alt="RASH Logo">
            </div>
        `;
    }

    selectDOMElements() {
        // Only after we have calling the render method
        // we can select the all DOM elements and save them in variables.
        this._parentElement = document.querySelector('.register');
        this._formElement = this._parentElement.querySelector('.form');
        this._selectUniversitiesElement = this._parentElement.querySelector('.form__input--universities');
        this._selectFacultiesElement = this._parentElement.querySelector('.form__input--faculties');
        this._inputFistNameElement = this._parentElement.querySelector('.form__input--first-name');
        this._inputLastNameElement = this._parentElement.querySelector('.form__input--last-name');
        this._selectPositionsElement = this._parentElement.querySelector('.form__input--positions');
        this._inputEmailElement = this._parentElement.querySelector('.form__input--email');

        // Only after we have selected all inputs we can set our custom validity
        this._setInputCustomValidity(this._selectUniversitiesElement, 'Zgjidhni universitetin');
        this._setInputCustomValidity(this._selectFacultiesElement, 'Zgjidhni fakultetin');
        this._setInputCustomValidity(this._inputFistNameElement, 'Vendosni emrin');
        this._setInputCustomValidity(this._inputLastNameElement, 'Vendosni mbiemrin');
        this._setInputCustomValidity(this._selectPositionsElement, 'Zgjidhni pozicionin');
    };

    _generateMarkupSelectUniversities(universities) {
        return universities.map(uni => `<option value="${uni.id}">${uni.name}</option>`).join('');
    }

    generateMarkupSelectFaculties(faculties) {
        if (this._selectUniversitiesElement.value) {
            this._selectFacultiesElement.innerHTML = '';
            this._selectFacultiesElement.insertAdjacentHTML(
                'beforeend',
                `
                <option class="select__option" value="">...Zgjidhni fakultetin *</option>
                ${faculties.map(fac => `<option value="${fac.id}">${fac.name}</option>`).join('')}
            `);
            this._selectFacultiesElement.disabled = false;
            return;
        }

        this._selectFacultiesElement.innerHTML = '';
        this._selectFacultiesElement.insertAdjacentHTML(
            'beforeend',
            `
                <option class="select__option" value="">...Zgjidhni fakultetin *</option>
            `);
        this._selectFacultiesElement.disabled = true;
    }

    updateMarkupInputEmail(faculty) {
        this._inputEmailElement.disabled = false;
        this._inputEmailElement.setAttribute(
            'placeholder',
            `shembull@${faculty?.domain ? faculty?.domain : 'rash.al'}`
        );
        this._inputEmailElement.setAttribute(
            'pattern',
            `^([a-zA-Z0-9_\\-\\.]+)@${faculty?.domain ? faculty?.domain : 'rash.al'}`
        );
        this._setInputCustomValidity(
            this._inputEmailElement,
            `Email-i duhet të ketë formatin: shembull@${faculty?.domain ? faculty?.domain : 'rash.al'}`
        );
    }

    addHandleSelectUniversity(handler) {
        // Guard close. We need to check for this case because this view can be without a select.
        if (!this._selectUniversitiesElement) return;

        this._selectUniversitiesElement.addEventListener('change', function () {
            handler(+this.value);
        });
    }

    addHandlerSelectFaculty(handler) {
        // Guard close. We need to check for this case because this view can be without a select.
        if (!this._selectFacultiesElement) return;

        this._selectFacultiesElement.addEventListener('change', function () {
            handler(+this.value);
        });
    }

    addHandlerForm(handler) {

        // Guard close. We need to check for this case because this view can be without a form.
        if (!this._formElement) return;

        const handlerSubmit = function (e) {

            e.preventDefault();

            const dataArr = [...new FormData(this._formElement)];
            const data = Object.fromEntries(dataArr)
            handler(data);
        };

        this._formElement.addEventListener('submit', handlerSubmit.bind(this));
    }

    renderError(message = this._errorMessage) {
        this._clear();
        this._parentElement.insertAdjacentHTML(
            'beforeend',
            `
                <h3 class="register__successMessage">Dicka nuk shkoj si duhet!!! Kërkesa nuk u dërgua.</h3> 
                <h3 class="register__successMessage">Ju lutem provoni perseri</h3>
            `
        );
    }

    renderSuccess(message = this._successMessage) {
        this._clear();
        this._parentElement.insertAdjacentHTML(
            'beforeend',
            `
                <h3 class="register__successMessage">Kërkesa u dërgua për miratim tek administrata e universitetit tuaj.</h3> 
                <h3 class="register__successMessage">Konfirmimi dhe Fjalëkalimi do ju vijë në email.</h3>
            `
        );
    }

    _setInputCustomValidity(input, message) {

        // Guard close. We need to check for this case because this view can be without any inputs.
        if (!input) return;

        input.addEventListener("invalid", function () {
            if (input.validity.typeMismatch || input.validity.patternMismatch || input.value === '') {
                input.setCustomValidity(message);
            } else {
                input.setCustomValidity("");
            }
        });

        input.addEventListener("input", function () {
            if (input.validity.typeMismatch || input.validity.patternMismatch || input.value === '') {
                input.setCustomValidity(message);
            } else {
                input.setCustomValidity("");
            }
        });
    }
}

export default new RegisterView();
